module.exports = __webpack_public_path__ + "910e20f7d3243dee70139759f920f689.svg";